import React from 'react';
import { AiMode } from '../../api/cafAutomation';
import { MODE_LABEL } from '../curation/automation/automationCopy';
import { AiSwitchState } from '../curation/automation/useAiSwitch';

/** An older backend keeps the Processors controls when the switch route is missing. */
export const switchMoved = (aiSwitch: AiSwitchState): boolean => aiSwitch.status === 'ready' && aiSwitch.value !== null;

const TONES: Record<AiMode, { background: string; color: string }> = {
  on: { background: 'var(--color-primary-100)', color: 'var(--color-primary-800)' },
  watching: { background: 'var(--color-info-100)', color: 'var(--color-info-600)' },
  off: { background: 'var(--color-neutral-100)', color: 'var(--color-neutral-700)' },
};

export const AutomationSwitchNotice: React.FC<{ mode: AiMode }> = ({ mode }) => (
  <div role="status" style={{
    display: 'flex', alignItems: 'center', gap: 12, flexWrap: 'wrap', margin: '12px 0', padding: '10px 14px',
    border: '1px solid var(--color-info-100)', background: 'var(--color-info-50)', borderRadius: 'var(--ds-radius)',
  }}>
    <span>Switched on and off from AI Curation › Automation</span>
    <span style={{ ...TONES[mode], padding: '2px 10px', borderRadius: 999, fontSize: 12, fontWeight: 600 }}>{MODE_LABEL[mode]}</span>
    <a className="ui-btn ui-btn--secondary ui-btn--sm" href="/ai-curation?automation=1">Open Automation</a>
  </div>
);
